import OverviewDistrictCard from './OverviewDistrictCard';
import { UserDetails } from '../../interfaces/UserDetailsInterface';
import Loader from '../reusable/Loader';
import OverviewStepCard from './OverviewStepCard';
import DataUploadIcon from '../assets/nav-data-upload.svg';
import DataQcIcon from '../assets/nav-data-qc.svg';
import CourseMappingIcon from '../assets/nav-course-mapping.svg';
import useUploadProgress from '../hooks/useUploadProgress';
import useDistrictRequiresTestScores from '../hooks/useDistrictRequiresTestScores';
import { USER_ROLES, DATA_CATEGORY_LABELS, fileTypes } from '../../constants';
import { CategoryData } from './OverviewDistrictCard';

interface OverviewContentProps {
  userDetails: UserDetails;
}

const isCourseMappingStepActive = (notStartedCategories: CategoryData[]) =>
  !notStartedCategories.some((category) => category.categoryName === DATA_CATEGORY_LABELS[fileTypes.COURSE_CATALOG]);

const withoutTestScores = (categories: CategoryData[]) =>
  categories.filter((category) => category.categoryName !== DATA_CATEGORY_LABELS[fileTypes.TEST_SCORES]);

function DistrictDataLeadView({ userDetails }: OverviewContentProps) {
  const {
    uploadProgressSummary: { isPending, error, data },
  } = useUploadProgress();
  const { requiresTestScores, isPending: isSchoolsConfigPending } = useDistrictRequiresTestScores();

  if (isPending || isSchoolsConfigPending) return <Loader />;
  if (error || !data) return <p>Error occured while fetching upload progress data!</p>;

  const { pending, progress, completed, errors } = requiresTestScores
    ? data
    : {
        pending: withoutTestScores(data.pending),
        progress: withoutTestScores(data.progress),
        completed: withoutTestScores(data.completed),
        errors: withoutTestScores(data.errors),
      };
  const isDistrictDataLead = userDetails.role === USER_ROLES.DISTRICT_DATA_LEAD;

  return (
    <>
      {isDistrictDataLead && (
        <div className="overview-step-cards">
          <OverviewStepCard
            cardIcon={DataUploadIcon}
            stepNumber={1}
            cardTitle="Upload your data"
            cardDescription="Upload student rosters, course catalogs, and other audit data requirements."
            buttonText="Upload data"
            isActive={pending.length + progress.length !== 0}
            redirectTo="/data-upload"
          />
          <OverviewStepCard
            cardIcon={CourseMappingIcon}
            stepNumber={2}
            cardTitle="Check your mapping"
            cardDescription={'Review your course catalog\nmapping and make any\nnecessary edits.'}
            buttonText="Check mapping"
            isActive={isCourseMappingStepActive(pending)}
            redirectTo="/course-mapping"
          />
          <OverviewStepCard
            cardIcon={DataQcIcon}
            stepNumber={3}
            cardTitle="Check your data"
            cardDescription="Review your data to catch and fix any errors."
            buttonText="Check data"
            isActive={pending.length + progress.length === 0}
            redirectTo="/data-qc"
          />
        </div>
      )}
      <OverviewDistrictCard
        districtName={userDetails.district.name}
        notStartedCategories={pending}
        inProgressCategories={progress.concat(errors)}
        completedCategories={completed}
      />
    </>
  );
}

export { DistrictDataLeadView, isCourseMappingStepActive };
